import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { AnalyticsEvent, getPlausibleClassName } from 'utils/analytics';

import Title, { TitleTypes } from '../../Title';
import Tag from '../../Tag';

const handleClick = () => {
    if (window) {
        window.ga('send', 'event', {
            eventCategory: 'Link',
            eventAction: 'click',
            eventLabel: 'carousel_click_on_reference',
            transport: 'beacon',
        });
    }
};

const CaseStudyHeader = ({ styles, heading, subHeading, tags, link, rules, isLast, logo }) => {
    const { formatMessage } = useIntl();
    const localizedLink = formatMessage({ id: link });
    const localizedTags = !isLast ? formatMessage({ id: tags }) : undefined;

    return (
        <header className={styles.container}>
            {!isLast && (
                <div className={styles.tagsContainer}>
                    {localizedTags &&
                        localizedTags
                            .split(',')
                            .map(tag => <Tag extend={{ container: rules.tagContainer }} key={tag} name={tag} />)}
                </div>
            )}

            {localizedLink === '#' ? (
                <Title
                    dataEventId={isLast ? 'carousel-content-link' : 'carousel-title-link'}
                    extend={rules.extendTitle}
                    type={TitleTypes.H1_ITALIC_UPPERCASE}
                    as={TitleTypes.H3}
                >
                    <FormattedMessage id={heading} />
                </Title>
            ) : (
                <a
                    onClick={handleClick}
                    data-event-id={isLast ? 'carousel-content-link' : 'carousel-title-link'}
                    href={localizedLink}
                    className={getPlausibleClassName(styles.link, AnalyticsEvent.CAROUSEL_TITLE_CLICK, {
                        click_text: heading,
                        // TODO: add missing carousel type property
                    })}
                >
                    <Title extend={rules.extendTitle} type={TitleTypes.H1_ITALIC_UPPERCASE} as={TitleTypes.H3} hasLink>
                        <FormattedMessage id={heading} />
                    </Title>
                </a>
            )}

            <Title extend={rules.extendSubtitleB} type={TitleTypes.H4} as={TitleTypes.H4}>
                <FormattedMessage id={subHeading} />
            </Title>

            {logo ? <div className={styles.logo} /> : null}
        </header>
    );
};

CaseStudyHeader.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string,
        link: PropTypes.string,
        buttonsContainer: PropTypes.string,
        tagsContainer: PropTypes.string,
    }).isRequired,
    heading: PropTypes.string.isRequired,
    subHeading: PropTypes.string.isRequired,
    tags: PropTypes.string,
    link: PropTypes.string.isRequired,
    rules: PropTypes.shape().isRequired,
    isLast: PropTypes.bool.isRequired,

    // used in styles
    isMoving: PropTypes.bool.isRequired,
    transitionDuration: PropTypes.number.isRequired,
};

CaseStudyHeader.defaultProps = {
    tags: undefined,
};

export default CaseStudyHeader;
